import { render, staticRenderFns } from "./ProductAgoraDocumentationModal.vue?vue&type=template&id=f8406076&scoped=true&"
import script from "./ProductAgoraDocumentationModal.vue?vue&type=script&lang=js&"
export * from "./ProductAgoraDocumentationModal.vue?vue&type=script&lang=js&"
import style0 from "./ProductAgoraDocumentationModal.vue?vue&type=style&index=0&id=f8406076&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8406076",
  null
  
)

export default component.exports